﻿import { useState, useEffect } from "react";
import { useParams, useLocation, useNavigate } from "react-router-dom";
import { Row, Col, Form, Modal, Button } from "react-bootstrap";
import { useToasts } from "react-toast-notifications";
import { validate, format } from "rut.js";

import { toast, validRoles } from "@/services/Utils";

import classes from "../../maintainers.module.scss";
import Fetching from "@/components/Fetching/Fetching";

import { base_dealer } from "../dealers.constants";
import api from "@/services/api.service";

const IncidentsForm = ({ confirmSave }) => {
	const { addToast } = useToasts();
	const location = useLocation();
	const { option, dealer_id } = useParams();
	const navigate = useNavigate();

	const [isFetching, setIsFetching] = useState(true);
	const [data, setData] = useState({ ...base_dealer });

	const userRoles = JSON.parse(localStorage.getItem("roles"));
	const isAdmin = validRoles(userRoles, ["administrador"]);

	const handleClose = () => {
		emptyFields();
		if (location.state) {
			navigate(location.state);
			return;
		}

		navigate("/mantenedores/distribuidores");
	};

	const validSave = () => {
		if (!data.rut_dealer) {
			toast(addToast, "Debe ingresar un RUT para guardar.", "error");
			return false;
		}

		if (data.rut_dealer && !validate(data.rut_dealer)) {
			toast(addToast, "Debe ingresar un RUT válido para continuar.", "error");
			return false;
		}

		if (!data.name) {
			toast(addToast, "Debe ingresar un nombre para guardar.", "error");
			return false;
		}

		return true;
	};

	const handleSave = () => {
		if (validSave()) {
			data.rut_dealer = format(data.rut_dealer);
			confirmSave({ form: data }, setIsFetching, afterSave);
		}
	};

	const emptyFields = () => {
		setData({ ...base_dealer });
	};

	const afterSave = () => {
		handleClose();
		addToast("Distribuidor guardado correctamente.", {
			appearance: "success",
		});
	};

	useEffect(() => {
		setIsFetching(true);
		if (option && dealer_id) {
			api.get("/admin/dealers/detail", { selected: dealer_id }).then((response) => {
				const { detail } = response;
				if (detail) {
					setData(detail);
				} else {
					addToast("Ocurrió un problema al cargar el distribuidor seleccionado.", {
						appearance: "error",
					});
					handleClose();
				}
				setIsFetching(false);
			});
		} else {
			setIsFetching(false);
		}
		// eslint-disable-next-line
	}, [dealer_id, option]);

	return (
		<Modal show={option ? true : false} onHide={handleClose} backdrop="static" keyboard={false} className={classes.main_form}>
			<Modal.Header closeButton>
				<h4 className={classes.modal_title}>Distribuidor</h4>
			</Modal.Header>

			<Modal.Body>
				{isFetching ? (
					<Fetching topMargin={"1em"} />
				) : (
					<Row className={classes.row_form}>
						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>RUT</Form.Label>
								<Form.Control
									value={data.rut_dealer ? data.rut_dealer : ""}
									onChange={(e) =>
										setData({
											...data,
											rut_dealer: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre Corto</Form.Label>
								<Form.Control
									value={data.common_name ? data.common_name : ""}
									onChange={(e) =>
										setData({
											...data,
											common_name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>

						<Col md={12} xs={12}>
							<Form.Group className={classes.group_form}>
								<Form.Label className={classes.label}>Nombre</Form.Label>
								<Form.Control
									value={data.name ? data.name : ""}
									onChange={(e) =>
										setData({
											...data,
											name: e.currentTarget.value,
										})
									}
									type="text"
								/>
							</Form.Group>
						</Col>
					</Row>
				)}
			</Modal.Body>
			<Modal.Footer>
				{isAdmin && !isFetching && (
					<Button variant="success" onClick={handleSave}>
						GUARDAR
					</Button>
				)}
			</Modal.Footer>
		</Modal>
	);
};

export default IncidentsForm;
